import { _Locale } from "./supportedLocale";

export interface FormatNumberArgs {
  value: unknown;
  locale?: _Locale;
  minimumFractionDigits: number;
  maximumFractionDigits: number;
}

type FormatNumber = (args: FormatNumberArgs) => string;

export const formatNumber: FormatNumber = ({
  value,
  locale = "en-US",
  minimumFractionDigits,
  maximumFractionDigits,
}) => {
  const num = Number(value);
  // Fallback to string value.
  if (isNaN(num)) return String(value);
  return num.toLocaleString(locale, { minimumFractionDigits, maximumFractionDigits });
};
